import { GenericActions } from "../../../redux/generic-actions";
import { GenericFormActions } from "../actions";

export function formCtasReducerFactory(rootProp, initialState) {
    return function formCtasReducer(state = initialState, action) {
        const stateProp: string = action.stateProp;
        switch (action.type) {
            case `${rootProp}::${GenericFormActions.FORM_OPENED}`:
                return state.setIn([stateProp, "isFormVisible"], true);

            case `${rootProp}::${GenericFormActions.FORM_CLOSED}`:
                return state.setIn([stateProp, "isFormVisible"], false);

            case `${rootProp}::${GenericActions.STATE_RESET}`:
                return state.delete(stateProp);

            default:
                return state;
        }
    };
}
